import { useEffect } from 'react';

/**
 * While the driver view is on screen, the page's install manifest is the
 * DELIVERY one (start_url /delivery/driver), so "Install app" opens the route,
 * not the admin dashboard. public/index.html sets the same on a direct load of
 * /delivery/driver; this covers arriving by in-app navigation after login.
 */
export function useDeliveryManifest(): void {
  useEffect(() => {
    const link = document.querySelector('link[rel="manifest"]') as HTMLLinkElement | null;
    const meta = document.querySelector('meta[name="theme-color"]') as HTMLMetaElement | null;
    const prevHref = link?.getAttribute('href') ?? null;
    const prevColor = meta?.content ?? null;
    const prevTitle = document.title;
    if (link) link.setAttribute('href', '/delivery-manifest.json');
    if (meta) meta.content = '#059669';
    document.title = 'RBF Deliveries';
    return () => {
      if (link && prevHref) link.setAttribute('href', prevHref);
      if (meta && prevColor) meta.content = prevColor;
      document.title = prevTitle;
    };
  }, []);
}
